import * as React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

const base =
    "inline-flex items-center justify-center gap-2 font-bold font-poppins tracking-[0.3px] rounded-bio select-none focus:outline-none focus-visible:ring-4 focus-visible:ring-[#2A87C8]/20 disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none transition-[transform,box-shadow,background-color,color,border-color] duration-200 ease-out";

const sizes = {
    sm: "h-10 px-4 text-sm",
    md: "h-12 px-6 text-[15px]",
    kiosk: "h-14 px-8 text-base",
    icon: "h-12 w-12 p-0",
};

const variants = {
    primary:
        "bg-bio-gradient text-white shadow-bio-btn hover:-translate-y-px hover:shadow-bio-btn-hover active:translate-y-0 active:brightness-95",
    secondary:
        "bg-white border-[1.5px] border-bio-accent text-bio-primary hover:bg-[#EEF7FC] hover:border-bio-primary hover:text-bio-primary-dark active:bg-[#E0EFF8]",
    ghost: "bg-transparent text-bio-text hover:bg-bio-bg-alt hover:text-bio-primary active:bg-bio-border-subtle",
    destructive:
        "bg-bio-error text-white hover:bg-[#961212] hover:shadow-[0_4px_14px_rgba(183,28,28,0.35)] active:bg-[#7A0E0E]",
};

export const BioButton = React.forwardRef(
    (
        {
            className,
            variant = "primary",
            size = "md",
            loading = false,
            disabled,
            children,
            ...props
        },
        ref,
    ) => {
        return (
            <button
                ref={ref}
                disabled={disabled || loading}
                className={cn(base, sizes[size], variants[variant], className)}
                {...props}
            >
                {loading && <Loader2 className="h-4 w-4 animate-spin" />}
                {children}
            </button>
        );
    },
);
BioButton.displayName = "BioButton";
